import React from 'react';
import SchemaManager from '../../components/SchemaManager';

const AdminCollections = () => {
  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Collections</h2>
        <small className="text-muted">
          Gérer les collections du site
        </small>
      </div>
      
      <SchemaManager
        schemaKey="collections"
        endpoint="/api/collections"
      />
    </div>
  );
};

export default AdminCollections;